export default __webpack_public_path__ + "static/media/blogimg.60662687.png";